import axios, {HttpStatusCode} from "axios";

//TODO replace the enviroment variable with a centralized backend url at some point
export const createUser = async (username, email, password) => {
    const user = {username, email, password}
    return await axios.post(`${process.env.REACT_APP_BACKEND_URL}/user/create`, user)
}

export const login = async (username, password) => {
    const userLoginInfo = {username, password}

    const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/user/login`, userLoginInfo, {withCredentials: true})
    const { sessionId } = await response.data;
    sessionStorage.setItem("sessionId", sessionId)
}

export const logout = async () => {
    await axios.post(`${process.env.REACT_APP_BACKEND_URL}/user/logout`, null, {withCredentials: true})
    sessionStorage.removeItem("sessionId")
}

//With credentials=true is only necessary for development, we need a setup so it is not allowed in production
export const retrieveUser = async () => {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/user`, {withCredentials: true})
    if(response.status === HttpStatusCode.Forbidden || response.status === HttpStatusCode.Unauthorized) {
        throw new Error("User cannot be retrieved - no valid user is logged in")
    }
    return await response.data
}

export const retrieveTempUsername = async (sessionId) => {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/user/temp-username`, {
        headers: {
            "Session-ID": sessionId
        }
    })
    return response.data
}
